<bav-reporting-feature-ais-reports-report-details
  #withIsChangedSupport
  [initialState]="state$ | async"
  (setReportStateTriggered)="onSetReportStateTriggered($event)"
></bav-reporting-feature-ais-reports-report-details>
